  <template>
      <div class="class-1">
        <!-- Header -->
        <AppHeader title="Tables Management" />
    
        <!-- Add New Table Button -->
        <button class="add-table-btn" @click="openTableModal">Add New Table</button>
        
        
        <div class="modal" v-if="showTableModal" key="table-modal">
        <div class="modal-dialog" role="document">
          <div>
            <div style="margin: 25px; background-color: rgba(82, 65, 76, 1); border-radius: 5px; height: 100%;">
              <div class="modal-header">
                <h5 class="modal-title">NEW TABLE</h5>
              </div>
              <div class="modal-body1 d-flex flex-column justify-content-between">
                <form @submit.prevent="handleSubmit">
                  <div class="searchbyphone d-flex flex-row">
                    <div class="infobox fieldOuter">
                      <input 
                        type="text" 
                        autocomplete="off" 
                        placeholder="Table Name"  
                        id="tableName" 
                        v-model="tableName"
                        ref="tableNameInput"
                        @click="openKeypad"
                      >
                    </div>
                    <span class="icon1 icon2" @click="openKeypad">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                        <path d="M512 448H64c-35.35 0-64-28.65-64-64V128c0-35.35 28.65-64 64-64h448c35.35 0 64 28.65 64 64v256C576 419.3 547.3 448 512 448zM128 180v-40C128 133.4 122.6 128 116 128h-40C69.38 128 64 133.4 64 140v40C64 186.6 69.38 192 76 192h40C122.6 192 128 186.6 128 180zM224 180v-40C224 133.4 218.6 128 212 128h-40C165.4 128 160 133.4 160 140v40C160 186.6 165.4 192 172 192h40C218.6 192 224 186.6 224 180zM320 180v-40C320 133.4 314.6 128 308 128h-40C261.4 128 256 133.4 256 140v40C256 186.6 261.4 192 268 192h40C314.6 192 320 186.6 320 180zM416 180v-40C416 133.4 410.6 128 404 128h-40C357.4 128 352 133.4 352 140v40C352 186.6 357.4 192 364 192h40C410.6 192 416 186.6 416 180zM512 180v-40C512 133.4 506.6 128 500 128h-40C453.4 128 448 133.4 448 140v40C448 186.6 453.4 192 460 192h40C506.6 192 512 186.6 512 180zM128 276v-40C128 229.4 122.6 224 116 224h-40C69.38 224 64 229.4 64 236v40C64 282.6 69.38 288 76 288h40C122.6 288 128 282.6 128 276zM224 276v-40C224 229.4 218.6 224 212 224h-40C165.4 224 160 229.4 160 236v40C160 282.6 165.4 288 172 288h40C218.6 288 224 282.6 224 276zM320 276v-40C320 229.4 314.6 224 308 224h-40C261.4 224 256 229.4 256 236v40C256 282.6 261.4 288 268 288h40C314.6 288 320 282.6 320 276zM416 276v-40C416 229.4 410.6 224 404 224h-40C357.4 224 352 229.4 352 236v40C352 282.6 357.4 288 364 288h40C410.6 288 416 282.6 416 276zM512 276v-40C512 229.4 506.6 224 500 224h-40C453.4 224 448 229.4 448 236v40C448 282.6 453.4 288 460 288h40C506.6 288 512 282.6 512 276zM128 372v-40C128 325.4 122.6 320 116 320h-40C69.38 320 64 325.4 64 332v40C64 378.6 69.38 384 76 384h40C122.6 384 128 378.6 128 372zM416 372v-40C416 325.4 410.6 320 404 320h-232C165.4 320 160 325.4 160 332v40C160 378.6 165.4 384 172 384h232C410.6 384 416 378.6 416 372zM512 372v-40C512 325.4 506.6 320 500 320h-40C453.4 320 448 325.4 448 332v40C448 378.6 453.4 384 460 384h40C506.6 384 512 378.6 512 372z"/>
                      </svg>
                    </span>
                  </div>

                  <Keypad 
                  ref="keypad"
                  v-if="showKeypad"
                  :target-input="$refs.tableNameInput"
                  @update:value="updateTableName"
                  @cancel="closeKeypad"
                />

                  <div class="buttons d-flex flex-row justify-content-end">
                    <div class="cancel" @click.stop="closeTableModal"> 
                      <span>Cancel</span>
                    </div>
                    <div class="submit" @click.stop="handleSubmit"> 
  <span>{{ isEditing ? 'Update' : 'Submit' }}</span>
</div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
        <!-- Table Structure -->
        <table id="tablesTable">
          <thead>
            <tr>
              <!-- <th>ID</th> -->
              <th>Name</th>
              <th>Waiter</th>
              <th>User</th>
              <th>Operations</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(table, index) in tables" :key="index">
              <!-- <td>{{ table.id }}</td> -->
              <td>{{ table.name }}</td>
              <td>
                <span v-if="table.waiter">{{ table.waiter.name }}</span>
                <span v-else class="text-muted">No waiter assigned</span>
              </td>
              <td>
                <span v-if="table.user">{{ table.user.name }}</span>
                <span v-else class="text-muted">No user assigned</span>
              </td>
              <td class="action-buttons">
                <button data-tooltip="Edit" @click="handleEdit(table)">
                  <img src="@/assets/edit_icon.png" alt="Edit">
                </button>
                <!-- <button 
                  data-tooltip="Delete" 
                  @click="handleDelete(table)"
                  class="delete-btn"
                >
                  <img src="@/assets/delete_icon.png" alt="Delete">
                </button> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    
<script>
import Keypad from './keypad_popup_component.vue';
export default {
  components: {
    Keypad
  },
  data() {
    return {
      showTableModal: false,
      showKeypad: false,
      isSuspend: false,
      tableName: '',
      branchId: localStorage.getItem('branchId'),
      tables: [],
      currentTableId: null, 
      isEditing: false 
    };
  },
  mounted() {
    this.fetchTables();
    this.isSuspend = localStorage.getItem('isWaiterSuspended');
  },
  methods: {
    openTableModal() {
      if (!this.$hasPermission('create tables')){
        this.$toast.error('Not Permitted');
        return;
      }
      this.$router.push({ name: "PosComponent", params: { showmodal: true} });
    },
    closeTableModal() {
      this.showTableModal = false;
      this.tableName = '';
      this.currentTableId = null;
      this.isEditing = false;
    },
    openKeypad() {
      this.showKeypad = true;
      this.$nextTick(() => {
        const input = this.$refs.tableNameInput;
        if (input) {
          input.focus();
          input.selectionStart = input.selectionEnd = input.value.length;
        }
      });
    },
    closeKeypad() {
      this.showKeypad = false;
    },
    updateTableName(value) {
      this.tableName = value;
      this.closeKeypad();
    },
    async handleSubmit() {
      this.$router.push({ name: "PosComponent", params: { showmodal: true} });
    },
    async fetchTables() {
      try {
        this.$root.isLoading = true;
        this.loading = true;
        const token = localStorage.getItem('authToken');
        const appId = localStorage.getItem('appId');
        const branchId = localStorage.getItem('WaiterBranchId'); 

        if (!branchId) {
          throw new Error('WaiterBranchId not found in localStorage');
        }

        const response = await fetch(`${this.$BASE_API_URL}/api/tables?appId=${appId}&branchId=${branchId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error('Failed to fetch tables');

        const { data } = await response.json();
        
        this.tables = await Promise.all(
          data.map(async (table) => {
            const tableWithDetails = { ...table };
            
            if (table.waiterId) {
              tableWithDetails.waiter = await this.fetchWaiter(table.waiterId);
            }

            if (table.userId) {
              tableWithDetails.user = await this.fetchUser(table.userId);
            }

            return tableWithDetails;
          })
        );
      } catch (error) {
        console.error('Error fetching tables:', error);
        this.$toast.error('Failed to load table data');
      } finally {
        this.$root.isLoading = false;
        this.loading = false;
      }
    },
    async fetchWaiter(waiterId) {
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${this.$BASE_API_URL}/api/waiters/${waiterId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error('Failed to fetch waiter');
        const { data } = await response.json();
        return data;
      } catch (error) {
        console.error('Error fetching waiter:', error);
        return null;
      }
    },
    async fetchUser(userId) {
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${this.$BASE_API_URL}/api/users/${userId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error('Failed to fetch user');
        const { data } = await response.json();
        return data;
      } catch (error) {
        console.error('Error fetching user:', error);
        return null;
      }
    },
    navigateToAddTable() {
      this.$router.push({ name: "AddTableComponent" });
    },
   async handleEdit(table) {
  if (!this.$hasPermission('edit tables')){
    this.$toast.error('Not Permitted');
    return;
  }
  
  if(this.isSuspend == 1){
    this.$toast.error('your account is not activated');
    return;
  }
  
  try {
    this.$root.isLoading = true; 
    this.loading = true;
    
    const token = localStorage.getItem('authToken');
    const appId = localStorage.getItem('appId');
    const branchId = localStorage.getItem('WaiterBranchId');
    
    // Fetch active orders for this table
    const ordersResponse = await fetch(`${this.$BASE_API_URL}/api/orders?appId=${appId}&branchId=${branchId}&tableId=${table.id}&status=active`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    let orderId = null;
    
    if (ordersResponse.ok) {
      const ordersData = await ordersResponse.json();
      if (ordersData.data && ordersData.data.length > 0) {
        // Get the most recent active order for this table by finding the one with the highest ID
        const sortedOrders = ordersData.data.sort((a, b) => b.id - a.id);
        orderId = sortedOrders[0].id; // This should be order 353
      }
    }

    // Navigate to POS with orderId and tableId
    if (orderId) {
      this.$router.push({ 
        name: "PosComponent", 
        params: { 
          orderId: orderId,
          tableId: table.id
        }
      });
    } else {
      // If no active order, just navigate with tableId
      this.$router.push({ 
        name: "PosComponent", 
        params: { 
          tableId: table.id
        }
      });
    }
  } catch (error) {
    console.error('Error fetching order details:', error);
    this.$toast.error('Failed to load order details');
  } finally {
    this.$root.isLoading = false;
    this.loading = false;
  }
},
    async handleDelete(table) {
      if (!this.$hasPermission('delete tables')){
        this.$toast.error('Not Permitted');
        return;
      }
      if (!confirm(`Are you sure you want to delete ${table.name}?`)) return;
      
      try {
        this.$root.isLoading = true; 
        this.loading = true;
        const token = localStorage.getItem('waiterToken');
        const response = await fetch(`${this.$BASE_API_URL}/api/tables/${table.id}?appId=${1}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error('Failed to delete table');
        this.tables = this.tables.filter(t => t.id !== table.id);
        this.$toast.success('Table deleted successfully');
      } catch (error) {
        console.error('Error deleting table:', error);
        this.$toast.error('Failed to delete table');
      } finally {
        this.$root.isLoading = false;
        this.loading = false;
      }
    },
  },
};
</script>
   <style scoped>
    
  .modal {
    z-index: 1050; 
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    /* height: 111%; */
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1 !important;
  }
  .modal * {
    pointer-events: auto;
  }
  .modal-dialog {
    pointer-events: auto;
    z-index: 1051; 
    max-width: 500px;
    width: 100%;
    
  }

  .add-table-btn {
    float: right;
    margin-bottom: 10px;
    padding: 10px;
    background-color: #4caf50;
    color: white;
    border: none;
    cursor: pointer;
    width: max-content;
    border-radius: 5px;
    margin-top: 0.5rem;
  }

  .searchbyphone {
    margin-bottom: 15px;
  }

  .infobox {
    position: relative;
    flex: 1;
  }

  .fieldOuter input {
    width: 100%;
    padding: 10px;
    border: 1px solid;
    border-radius: 4px;
    background-color: #f8f9fa;
  }

  .fieldOuter label {
    position: absolute;
    top: -10px;
    left: 10px;
    background-color: #f8f9fa;
    padding: 0 5px;
    font-size: 12px;
    color: #495057;
  }

  .icon1 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-left: 10px;
    background-color: #f8f9fa;
    border-radius: 4px;
    cursor: pointer;
  }

  .icon1 svg {
    width: 20px;
    height: 20px;
    fill: #495057;
  }

  .buttons {
    margin-top: 20px;
  }

  .cancel, .submit {
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 10px;
  }

  .cancel {
    background-color: #f8f9fa;
    color: #495057;
  }

  .submit {
    background-color: #4caf50;
    color: white;
  }
    .add-table-btn, .add-customer-btn {
      float: right;
      margin-right: 1rem;
      margin-bottom: 10px;
      padding: 10px;
      background-color: #4caf50;
      color: white;
      border: none;
      cursor: pointer;
      width: max-content;
      border-radius: 5px;
      margin-top: 0.5rem;
    }
    .action-buttons {
      display: flex;
      gap: 8px;
      position: relative; /* Required for tooltip positioning */
    }
    .action-buttons button {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 4px 8px;
      border-radius: 4px;
      border: none;
      cursor: pointer;
      transition: all 0.2s ease;
      position: relative; /* Required for tooltip */
    }
    .action-buttons button:hover {
      transform: scale(1.05);
    }
    .action-buttons button:hover::after {
      content: attr(data-tooltip);
      position: absolute;
      bottom: -25px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #333;
      color: #fff;
      padding: 5px;
      border-radius: 4px;
      font-size: 12px;
      white-space: nowrap;
    }
    .action-buttons button img {
      width: 20px;
      height: 20px;
    }
    /* Status colors */
    .text-success {
      color: #28a745;
    }
    .text-danger {
      color: #dc3545;
    }
    .text-muted {
      color: #6c757d;
      font-style: italic;
    }
    /* Button colors */
    .delete-btn img {
      filter: invert(20%) sepia(100%) saturate(500%) hue-rotate(300deg);
    }
    .suspend-btn {
      color: #dc3545;
    }
    .activate-btn {
      color: #28a745;
    }
    </style>